/**
 * Fase 2 (W24, K9): textos do cadastro rápido de fornecedor (`componentes/novo-fornecedor.tsx`), no núcleo porque o Compras
 * (compra direta) e o Contas (conta a pagar) usam o mesmo componente. Vieram do namespace do Compras sem mudar o texto.
 */
export const fornecedorRapidoPt = {
  fornecedorRapido: {
    titulo: 'Novo fornecedor',
    explicacao: 'Cadastro rápido no Cadastros. Os demais dados podem ser completados depois, na ficha.',
    nome: 'Nome ou razão social',
    documento: 'CPF ou CNPJ (opcional)',
    salvar: 'Cadastrar e usar',
    criado: 'Fornecedor cadastrado',
    // crm5 (E3): o CNPJ completo consulta a Receita e preenche o nome, se vazio.
    consulta: { buscando: 'Consultando a Receita', preenchido: 'Nome da Receita preenchido', naoEncontrado: 'CNPJ não encontrado na Receita', falha: 'Consulta indisponível agora. Preencha à mão.' },
  },
};

export const fornecedorRapidoEn: typeof fornecedorRapidoPt = {
  fornecedorRapido: {
    titulo: 'New supplier',
    explicacao: 'Quick record in Records. The other details can be filled in later, on the profile.',
    nome: 'Name or company name',
    documento: 'CPF or CNPJ (optional)',
    salvar: 'Create and use',
    criado: 'Supplier created',
    consulta: { buscando: 'Looking up the tax registry', preenchido: 'Name filled from the tax registry', naoEncontrado: 'CNPJ not found in the tax registry', falha: 'Lookup unavailable right now. Fill in by hand.' },
  },
};

export const fornecedorRapidoEs: typeof fornecedorRapidoPt = {
  fornecedorRapido: {
    titulo: 'Nuevo proveedor',
    explicacao: 'Registro rápido en Registros. Los demás datos se pueden completar después, en la ficha.',
    nome: 'Nombre o razón social',
    documento: 'CPF o CNPJ (opcional)',
    salvar: 'Registrar y usar',
    criado: 'Proveedor registrado',
    consulta: { buscando: 'Consultando la Receita', preenchido: 'Nombre de la Receita completado', naoEncontrado: 'CNPJ no encontrado en la Receita', falha: 'Consulta no disponible ahora. Complétalo a mano.' },
  },
};
